import { render, staticRenderFns } from "./PanchoWillies_drinkItem.vue?vue&type=template&id=05b82f49&scoped=true"
import script from "./PanchoWillies_drinkItem.vue?vue&type=script&lang=ts"
export * from "./PanchoWillies_drinkItem.vue?vue&type=script&lang=ts"
import style0 from "./PanchoWillies_drinkItem.vue?vue&type=style&index=0&id=05b82f49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b82f49",
  null
  
)

export default component.exports